import { useEffect, useRef } from 'react';
import { normalizeToastMessage, pushToast } from './toastService';

/**
 * props:
 * - text
 * - type
 */
function Toast(props) {
    const lastToastRef = useRef({ text: '', type: '' });

    useEffect(() => {
        const message = normalizeToastMessage(props.text);
        if (!message) return;

        const lastToast = lastToastRef.current;
        if (message === lastToast.text && props.type === lastToast.type) {
            return;
        }

        lastToastRef.current = { text: message, type: props.type };

        pushToast({
            type: props.type,
            text: message,
        });
    }, [props.type, props.text]);

    return null;
}

export default Toast;
export { pushToast } from './toastService';